module.exports = {
  title:'电子开标大厅',
  serviceTel:'400-0571-337',
  lanChenPhone:'191 0650 6216',
  caCheckUrl :process.env.VUE_APP_NODE === 'development'? "https://tca.zhaotx.cn/api/v1/ca-center/verify/ca":"https://ca.zhaotx.cn/api/v1/ca-center/verify/ca",
  stystemLx :'ztx',
  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}
